<ng-container *ngIf="stepInput.isBulkEdit">
  <div style="width: 95%">
    <app-items-for-bulk-edit [selectedItems]="stepInput.selectedLineItem" entityType="line_item" step="geo"
      [isBulkEdit]="true" dspType="tdsp">
    </app-items-for-bulk-edit>
  </div>
</ng-container>

<ng-container *ngIf="!isMediaPlan && !stepInput.isBulkEdit">
  <div style="display: flex;">
  <span
  matTooltip="AI-assisted optimization"
  matTooltipClass="tooltip-class"
  class="material-icons ai-icon ms-2 mt-2 align-middle"
>
  auto_awesome
</span>

<div class="flex_row field-name mt-2 ms-2" *ngIf="!stepInput.isBulkEdit">Geo Optimization
    <span matTooltip="Automatically
    allocates more budget to high-performing locations and regions to maximize
    campaign efficiency. Applies only for country/region/cities/postal code targeting."
      matTooltipClass="tooltip-class" class="material-icons tool-tip ms-1">
      error
    </span>
    <mat-slide-toggle class="ms-3" [(ngModel)]="geoOptimization" (change)="proceed()" [disabled]="selectedCustomLocation.length > 0">
    </mat-slide-toggle>
  </div>
</div>
</ng-container>

<div class="flex_row mb-3 mt-4">

  <mat-chip-listbox>
    <mat-chip-option (click)="getGeoChip('geo')" [selected]="selectedGeoChip == 'geo'">
      Country/Region/Cities
    </mat-chip-option>
    <mat-chip-option (click)="getGeoChip('postal_codes')" [selected]="selectedGeoChip == 'postal_codes'">
      Postal Codes
    </mat-chip-option>
    <mat-chip-option [selected]="selectedGeoChip == 'weather_temperature'" (click)="getGeoChip('weather_temperature')" *ngIf="allowWeatherTargeting || allowTemperatureTargeting">
      {{allowWeatherTargeting && allowTemperatureTargeting ? "Weather/Temperature" : allowTemperatureTargeting ? "Temperature" : allowWeatherTargeting ? "Weather" : ""}}
    </mat-chip-option>
    <mat-chip-option *ngIf="!isMediaPlan" (click)="getGeoChip('custom_location')" [selected]="selectedGeoChip == 'custom_location'">
      Custom Location
    </mat-chip-option>
  </mat-chip-listbox>

  <p *ngIf="!isMediaPlan" class="warning_message tooltip-class" style="float:right; margin-right: 25%;">
    Country/Region/City, Postal Code, or Custom Location targeting is required.
  </p>

</div>

<div class="list_container me-2" *ngIf="selectedGeoChip == 'geo'">
  <div class="mt-4 ms-3 me-3 mb-4">
    <div>
      <mat-form-field class="no-padding list-search" appearance="outline">
        <input matInput class="placeholders search-input-shadow" (keyup)="searchGeoData($event)"
          [(ngModel)]="geoSearchTerm" placeholder="Search {{ geoPrurals[selectedGeoTab] }}" #input />
        <mat-icon matSuffix class="material-icons search_icon">
          search
        </mat-icon>
      </mat-form-field>
       <p *ngIf="stepInput.isBulkEdit" class="warning_message tooltip-class" style="float:right; margin-right: 25%;">
        Selecting any of Country, Region, or City  will replace all existing geo selections.
      </p>
    </div>
    <div class="mt-2">
      <div class="tab-content">
        <div (click)="getGeoTab('country')" [ngClass]="{
            nav_tab: true,
            active: this.selectedGeoTab === 'country'
          }">
          Countries
        </div>
        <div (click)="getGeoTab('region')" [ngClass]="{
            nav_tab: true,
            active: this.selectedGeoTab === 'region'
          }">
          Region
        </div>
        <div (click)="getGeoTab('city')" [ngClass]="{ nav_tab: true, active: this.selectedGeoTab === 'city' }">
          Cities
        </div>
      </div>
      <div class="filter-chip-geo" *ngIf="geoFilter">
        <mat-chip-option [removable]="true">
          <div class="table_value_name mt-2">
            <label> {{ selectedGeoTab == 'city' ? geoFilter.GeoSegmentName.split("-").at(-1) : geoFilter.GeoSegmentName
              }}</label>
          </div>

          <mat-icon matChipRemove (click)="removeGeoFilter()">cancel</mat-icon>
        </mat-chip-option>
      </div>
    </div>

    <div class="deals_container mt-3">
      <div class="deals_sub_container">
        <div>
          <mat-error *ngIf="!isMediaPlan && stepInput.showTargetingError && !hasLocationTargeting()" style="font-size: 12px; display: block; margin-bottom: 8px;">
            Country/Region/City, Postal Code, or Custom Location targeting is required
          </mat-error>
          <table mat-table #geoSort="matSort" [dataSource]="dataSourceGeo" matSort>
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <ng-container>
                  <span matTooltip="Select to INCLUDE in targeting" [ngClass]="{
                        'material-icons me-2': true,
                        'include-icon-selected': isIncludeGeo(),
                        'include-icon': !isIncludeGeo()
                      }" (click)="
                        isIncludeGeo() ? addGeo(row, 'include') : ''
                      ">
                    check
                  </span>

                  <span matTooltip="Select to EXCLUDE in targeting" [ngClass]="{
                        'material-icons': true,
                        'exclude-icon-selected': isExcludeGeo(),
                        'exclude-icon': !isExcludeGeo()
                      }" (click)="
                        isExcludeGeo() ? addGeo(row, 'exclude') : ''
                      ">
                    block
                  </span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>
                <span class="table_header_name"> ID </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <a class="table_value_name pointer" style="color: black" (click)="getFilteredGeo(row)">
                  <!-- {{ selectedGeoTab != 'country' ? row.GeoSegmentName.split("-").at(-1) : row.GeoSegmentName }}</a> -->
                  <!-- {{ selectedGeoTab == 'country' ? row.GeoSegmentName : selectedGeoTab == 'region' ? row.GeoSegmentName.split('-').slice(1).join('-') : row.GeoSegmentName.split("-").at(-1)  }} -->

                    {{getGeoName(row, selectedGeoTab)}}
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="region_name">
              <th mat-header-cell *matHeaderCellDef>
                <span class="table_header_name"> Region Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{getRegionName(row)}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="country_name">
              <th mat-header-cell *matHeaderCellDef>
                <span class="table_header_name"> Country Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{row.GeoSegmentName.split("-").at(0) }}</span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnGeo"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnGeo"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
          <mat-paginator #geoPaginator [pageSizeOptions]="[10, 25, 100]" (page)="handlePageEvent($event)"
            [length]="pageLength">
          </mat-paginator>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div class="deals_sub_container">
              <div class="flex_column fix-height">
                    <mat-list>
                      <mat-list-item>
                        <div class="header-row">
                          <div class="col-name table_header_name">Name</div>
                          <div class="col-bid table_header_name">Bid Factor
                            <span
                            matTooltipClass="tooltip-preline"
                            class="material-icons tool-tip text-sm"
                            [matTooltip]="bidFactorTooltip"
                          >
                            error
                          </span>
                          </div>
                          <div class="col-action">
                            <span class="material-icons" style="cursor: pointer; color: gray" (click)="removeAllGeo()">
                              cancel
                            </span>
                          </div>
                        </div>
                      </mat-list-item>
                    </mat-list>
          
                    <div class="selected-list-content">
                      <div *ngIf="geoObject.length > 0" class="list_container_content">
                        <div class="country-group">
                          <div *ngFor="let geo of geoObject; let i = index">
                            <!-- Country Row -->
                            <div class="item-row">
                              <div class="col-name">
                                <div class="flex_row">
                                  <div *ngIf="geo.country_included">
                                    <span *ngIf="country_action == 'include'" class="material-icons allow-icon">check</span>
                                    <span *ngIf="country_action == 'exclude'" class="material-icons block-icon">block</span>
                                  </div>
                                  <span>{{ geo.country.name }}</span>
                                </div>
                              </div>
          
                              <div class="col-bid" *ngIf="geo.country_included">
                                <input type="number" [(ngModel)]="geo.bid_factor" placeholder="Value" autocomplete="off"
                                  [disabled]="geoOptimization || country_action == 'exclude'" (keyup)="proceed()" />
                              </div>
          
                              <div class="col-action" *ngIf="geo.country_included">
                                <span class="material-icons" (click)="removeCountry(i)">cancel</span>
                              </div>
                            </div>
          
                            <!-- Regions + Cities -->
                            <div *ngFor="let rgn of geo.regions; let j = index">
                              <!-- Region Row -->
                              <div class="item-row region-row">
                                <div class="col-name">
                                  <div class="flex_row">
                                    <div *ngIf="rgn.region_included">
                                      <span *ngIf="region_action == 'include'" class="material-icons allow-icon">check</span>
                                      <span *ngIf="region_action == 'exclude'" class="material-icons block-icon">block</span>
                                    </div>
                                    <span>{{ rgn.region.name }}</span>
                                  </div>
                                </div>
          
                                <div class="col-bid" *ngIf="rgn.region_included">
                                  <input type="number" [(ngModel)]="rgn.bid_factor" placeholder="Value" autocomplete="off"
                                    (keyup)="proceed()" [disabled]="geoOptimization || region_action == 'exclude'" />
                                </div>
          
                                <div class="col-action" *ngIf="rgn.region_included">
                                  <span class="material-icons" (click)="removeRegion(i, j)">cancel</span>
                                </div>
                              </div>
          
                              <!-- City Rows -->
                              <div *ngFor="let city of rgn.cities; let k = index">
                                <div class="item-row city-row">
                                  <div class="col-name">
                                    <div class="flex_row">
                                      <span *ngIf="city_action == 'include'" class="material-icons allow-icon">check</span>
                                      <span *ngIf="city_action == 'exclude'" class="material-icons block-icon">block</span>
                                      <span>{{ city.name }}</span>
                                    </div>
                                  </div>
          
                                  <div class="col-bid">
                                    <input type="number" [(ngModel)]="city.bid_factor" placeholder="Value" autocomplete="off"
                                      (keyup)="proceed()" [disabled]="geoOptimization || city_action == 'exclude'" />
                                  </div>
          
                                  <div class="col-action">
                                    <span class="material-icons" (click)="removeCity(i, j, k)">cancel</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- End Regions + Cities -->
                          </div>
                        </div>
                      </div>
                    </div>
          
                  </div>
                  
      </div>
    </div>
  </div>
</div>

<div class="me-2" *ngIf="selectedGeoChip == 'postal_codes'">
  <div class="list_container">
    <div class="postal-codes-container">
      <div class="deals_container">
        <div class="deals_sub_container">
          <mat-error *ngIf="!isMediaPlan && stepInput.showTargetingError && !hasLocationTargeting()" style="font-size: 12px; display: block; margin-bottom: 8px;">
            Country/Region/City, Postal Code, or Custom Location targeting is required
          </mat-error>
          <mat-form-field style="width: 20em;" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
            <mat-label>Country</mat-label>
            <mat-select required [(ngModel)]="selectedCountryIDForPostalCodes"
              placeholder="Choose One" [multiple]="false" #multiSelect>
              <mat-option>
                <ngx-mat-select-search (keyup)="applyFilterCountryForPostalCodes($event)"
                  [placeholderLabel]="'Search Countries'" [noEntriesFoundLabel]="'Not found'">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option class="green-checkbox" *ngFor="let item of allCountriesForPostalCodes"
                [value]="item.GeoSegmentName">
                {{ item.GeoSegmentName }}
              </mat-option>
            </mat-select>
            <mat-error>
              Choose a country
            </mat-error>
          </mat-form-field>
          <div class="text-input-inventory">
            <textarea [(ngModel)]="inputZipCodes" rows="10"
              placeholder="Enter postal codes separated by commas or newlines." style="width: 100%">
            </textarea>
          </div>

          <ng-container>
            <div class="text-input-action">
              <button mat-button class="action_btn_no-border me-2" (click)="clearAllTextFromPostalTextArea()">
                Clear
              </button>
              <button [disabled]="!inputZipCodes||!selectedCountryIDForPostalCodes" mat-button class="me-2 mb-2"
                (click)="addPostalCodes()"
                [ngClass]="{'create-btn-disabled': !inputZipCodes||!selectedCountryIDForPostalCodes, 'create-btn': true}">
                Add
              </button>
            </div>
          </ng-container>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="deals_sub_container">
          <div *ngIf="stepInput.isBulkEdit">
            <div class="field-name px-3">Operation:</div>
            <mat-radio-group [(ngModel)]="bulkEditTrgtAct.zip">
              <mat-radio-button class="ms-2" *ngFor="let item of trgtOperations" [value]="item.value" [matTooltip]="item.toolTip">
                {{ item.label }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="flex_column fix-height">
            <div>
              <div class="flex_column">
                <div class="list_container">
                  <div class="flex_row_space_between mt-2 mb-2 ms-2 me-2">
                    <span class="mt-1 table_header_name"> Postal Codes </span>
                    <div class="list-item-action align-right">
                      <span matTooltip="Select to INCLUDE in targeting" (click)="updatePostalCodeAction('include')"
                        [ngClass]="{
                          'material-icons': true,
                          'include-icon-selected': zip_action == 'include',
                          'include-icon': zip_action == 'exclude'
                        }">
                        check
                      </span>
                      <span matTooltip="Select to EXCLUDE in targeting" (click)="updatePostalCodeAction('exclude')"
                        [ngClass]="{
                          'material-icons': true,
                          'exclude-icon-selected': zip_action == 'exclude',
                          'ms-2': true,
                          'exclude-icon': zip_action == 'include'
                        }">
                        block
                      </span>
                    </div>
                    <span (click)="removeAllPostalCodes()" class="material-icons me-3"
                      style="cursor: pointer; color: gray">
                      cancel
                    </span>
                  </div>
                  <div>
                    <mat-divider [vertical]="false"></mat-divider>
                  </div>
                  <div class="selected-postal-codes">
                    <mat-chip-listbox style="width: 100%">
                      <mat-chip-option *ngFor="let code of selectedZip; let i = index" [removable]="true"
                        (removed)="removeSelectedPostalCodes(i)">
                        {{ code.code }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-option>
                    </mat-chip-listbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="me-2" *ngIf="selectedGeoChip == 'weather_temperature'">
  <ng-container *ngIf="allowWeatherTargeting">
    <div class="field-name">Weather
      <span matTooltipClass="tooltip-class" class="material-icons tool-tip ms-1"
            [matTooltip]="weatherTooltip">error</span>
    </div>
    <div class="d-flex align-items-center" *ngIf="stepInput.isBulkEdit">
      <div class="field-name px-0 py-0">Operation:</div>
      <mat-radio-group [(ngModel)]="bulkEditTrgtAct.weather_list">
        <mat-radio-button class="ms-2" *ngFor="let item of trgtOperations" [value]="item.value" [matTooltip]="item.toolTip">
          {{ item.label }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="flex_row mt-2">
      <mat-form-field class="name_input" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Weather</mat-label>
        <mat-select [disabled]="stepInput.isBulkEdit && bulkEditTrgtAct.weather_list === 'remove_all'" [(ngModel)]="selectedWeather" placeholder="Choose One or More" [multiple]="true"
          (selectionChange)="proceed()">
          <mat-option class="green-checkbox" *ngFor="let item of allAvailableWeather" [value]="item.id">
            {{ item.weather }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="allowTemperatureTargeting">
    <div class="field-name">Temperature
       <span matTooltipClass="tooltip-class" class="material-icons tool-tip ms-1"
            [matTooltip]="temperatureTooltip">error</span>
    </div>
    <div class="fx_column" [formGroup]="temperatureForm">
      <mat-form-field class="li_input_field" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Min Temperature(°C)</mat-label>
        <input matInput type="number" placeholder="Enter min temp" formControlName="temperatureMin"
          (keyup)="validateTemperature()" />
        <mat-error *ngIf="temperatureForm.get('temperatureMin')?.hasError('min')">
          Min temperature cannot be below -90°C
        </mat-error>
        <mat-error *ngIf="temperatureForm.get('temperatureMin')?.hasError('max')">
          Min temperature cannot exceed 60°C
        </mat-error>
      </mat-form-field>

      <mat-form-field class="li_input_field ms-3" appearance="outline" floatLabel="always"
        [class.mat-form-field-invalid]="temperatureForm.hasError('maxLessThanMin')">
        <mat-label>Max Temperature(°C)</mat-label>
        <input matInput type="number" placeholder="Enter max temp" formControlName="temperatureMax"
          (keyup)="validateTemperature()" />
        <mat-error *ngIf="temperatureForm.get('temperatureMax')?.hasError('min')">
          Max temperature cannot be below -90°C
        </mat-error>
        <mat-error *ngIf="temperatureForm.get('temperatureMax')?.hasError('max')">
          Max temperature cannot exceed 60°C
        </mat-error>
        <mat-error *ngIf="temperatureForm.hasError('maxLessThanMin')">
          Max temperature cannot be below Min temperature
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>

</div>

<div class="me-2" *ngIf="selectedGeoChip == 'custom_location'">

  <div class="field-name mt-2">Custom Location</div>
  <div class="list_container">
    <div class="deals_container mt-1">
      <div class="deals_sub_container">
        <div>
          <mat-form-field class="no-padding search-input-shadow ms-2 mt-2" appearance="outline">
            <input matInput class="placeholders" (keyup)="searchCustomLocation($event)" placeholder="Search" #input />
            <mat-icon matSuffix class="material-icons search_icon">
              search
            </mat-icon>
          </mat-form-field>
          <mat-error *ngIf="!isMediaPlan && stepInput.showTargetingError && !hasLocationTargeting()" style="font-size: 12px; display: block; margin-bottom: 8px;">
            Country/Region/City, Postal Code, or Custom Location targeting is required
          </mat-error>
          <table mat-table #customLocationSort="matSort" [dataSource]="dataSourceCustomLocation" matSort>

            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <label class="checkbox-container">
                  <input type="checkbox" (click)="addCustomLocationItem(row, $event)"/>
                  <span class="checkboxmark"></span>
                </label>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> ID </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name mt-2">{{ row.id }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name mt-2"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.name }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="level">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Level </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.level }}</span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayCustomLocationColumnList"></tr>
            <tr mat-row *matRowDef="let row; columns: displayCustomLocationColumnList"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                No data available
              </td>
            </tr>
          </table>
          <mat-paginator #inventoryPaginator [pageSizeOptions]="[10, 25, 100]" (page)="handlePageEvent($event)"
            [length]="pageLengthCustomLocation">
          </mat-paginator>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div class="deals_sub_container">
        <div class="flex_column fix-height">
          <span class="warning_message mt-2 mb-2" style="margin-left: 5%;">
            <ul>
              <li>Targeting is limited to a single custom location</li>
              <li *ngIf="stepInput.isGambling">
                Custom location targeting is available only for selected countries. Please
                click this link <a class="active pointer-cursor ms-1" (click)="avlCtryForTar()"
                  >to view the list.</a
              ></li>
            </ul>
          </span>
          <mat-list>
            <mat-list-item>
              <div class="flex_row_space_between" *ngIf="selectedCustomLocation.length>0">
                <div class="flex_row">
                  <label class="checkbox-container mt-1">
                    <input type="checkbox" [checked]="selectedCustomLocation.length>0"
                      (click)="removeAllCustomLocationItem()" />
                    <span class="checkboxmark"></span>
                  </label>
                  <span class="field-name mt-4">Name</span>
                </div>
                <div class="flex_row">
                  <span class="field-name mt-4 me-3">ID</span>
                  <!-- <span class="material-icons mt-1 me-1" style="cursor: pointer; color: gray"
                  (click)="removeAllSelectedSellersItem()">
                  cancel
                </span> -->
                </div>
              </div>
            </mat-list-item>
          </mat-list>
          <div class="selected-list-content">
            <div *ngIf="selectedCustomLocation.length > 0" class="list_container_content">
              <mat-list>
                <mat-list-item *ngFor="let item of selectedCustomLocation; let l = last">
                  <div class="flex_row_space_between">
                    <div class="flex_row">
                      <label class="checkbox-container">
                        <input type="checkbox" checked (click)="removeCustomLocationItem(item)" />
                        <span class="checkboxmark"></span>
                      </label>
                      <span class="ms-2 mt-2">
                        {{ item.name }}
                      </span>
                    </div>
                    <div class="flex_row">
                      <span class="me-2 mt-2">{{ item.id }}</span>
                    </div>
                  </div>
                  <mat-divider *ngIf="!l"></mat-divider>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>